import { useQuery } from "@tanstack/react-query";
import { JobDetails } from "features/types";
import { get } from "services/http";

export const useGetAutoReserveJobDetailQuery = ({
  enabled,
  userId,
}: {
  enabled: boolean;
  userId: number | undefined;
}) => {
  return useQuery(
    ["autoReserveJobDetail"],
    async () => {
      const response = await (get({
        url: "/jobs/auto_reserve",
      }) as Promise<JobDetails[]>);
      return response.find((job) => job.submittedBy.id === userId);
    },
    {
      enabled,
      refetchInterval: (data) => {
        const INTERVAL = 1000 * 60;
        if (data?.status === "COMPLETED" || data?.status === "FAILED") {
          return false;
        }
        return INTERVAL;
      },
    }
  );
};
